import React from 'react';
import PropTypes from 'prop-types';

import SrButton, {
  SR_BUTTON_FONT_SIZE_MICRO,
  SR_BUTTON_HEIGHT_SHORT,
  SR_BUTTON_HEIGHT_SHORTER,
  SR_BUTTON_THEME_ADOBE_BLUE,
} from 'client/components/SrButton/SrButton';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';

import SimpleCoverBadge from './SimpleCoverBadge';
import useTenantLiabilityLearnMoreModal from './useTenantLiabilityLearnMoreModal';

const UPTenantLiabilityBannerRow = ({ utilityPartner, onEnableClick, compact = false }) => {
  const { open: openLearnMore, modal: learnMoreModal } = useTenantLiabilityLearnMoreModal({
    utilityPartner,
  });

  return (
    <SrFlex
      align="center"
      justify="between"
      backgroundColor="#fff"
      border="0px solid #007AFF"
      borderWidth={compact ? '2px' : '0'}
      borderRadius={compact ? '7px' : '14px'}
      padding={compact ? '10px 14px' : '12px 16px'}
      boxShadow="0px 5px 21px 0px rgba(25, 51, 64, 0.1)"
    >
      <SimpleCoverBadge />

      <SrFlex align="center" flexWrap="wrap" justify="center">
        <SrText
          font="greycliff"
          size={compact ? '14' : '24'}
          weight="600"
          lineHeight={compact ? '16px' : '24px'}
          color="blue300"
        >
          Tenant Liability Protection&nbsp;
        </SrText>
        <SrText
          font="greycliff"
          size={compact ? '14' : '24'}
          weight="600"
          lineHeight={compact ? '16px' : '24px'}
          color="blueGreycliffText"
        >
          for your tenants.
        </SrText>
      </SrFlex>

      <SrFlex align="center" columnGap="16px" flexShrink="0">
        <button
          type="button"
          onClick={openLearnMore}
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '0 8px',
          }}
        >
          <SrText
            font="greycliff"
            size={compact ? '13' : '14'}
            weight="600"
            color="blue300"
            whiteSpace="nowrap"
          >
            Learn more
          </SrText>
        </button>
        <SrButton
          heightType={compact ? SR_BUTTON_HEIGHT_SHORTER : SR_BUTTON_HEIGHT_SHORT}
          fontSizeType={SR_BUTTON_FONT_SIZE_MICRO}
          minWidth="0"
          theme={SR_BUTTON_THEME_ADOBE_BLUE}
          onClick={onEnableClick}
          hasBoxShadow
        >
          Enable now
        </SrButton>
      </SrFlex>
      {learnMoreModal}
    </SrFlex>
  );
};

UPTenantLiabilityBannerRow.propTypes = {
  utilityPartner: PropTypes.object.isRequired,
  onEnableClick: PropTypes.func.isRequired,
  compact: PropTypes.bool,
};

UPTenantLiabilityBannerRow.displayName = 'UPTenantLiabilityBannerRow';

export default UPTenantLiabilityBannerRow;
